import { HiverAxios } from "h-commons";

export const userDeletionReasonsApi = async (selectedReasons, userIds) => {
    return new Promise((resolve, reject) => {
        HiverAxios({
            url: `/gx/api/user/deletion-reasons`,
            type: 'POST',
            params: {
                selectedReasons,
                userIds,
            },
            callback: response => resolve(response),
            onfail: error => reject(error.response),
        });
    });
}
